<!--Stand alone with tabs-->

@if (showRegister && !showLoader) {
  <div class="sign-up-card-wrapper bg-color-cream">
    <div data-testid="signup-container-div" class="sign-up-and-register bg-color-white">
      <!-- COMPANY LOGO -->
      <div class="logo-wrapper">
        <img data-testid="scoot-logo-image" src="assets/images/logos/scoot_logo_primary.png" alt="Scoot Logo" />
      </div>
      <!-- - - - - - - - - - - - - - SIGN IN - - - - - - - - - - - - -->
      <mat-tab-group
        mat-align-tabs="center"
        class="sign-tabs"
        [dynamicHeight]="true"
        [selectedIndex]="selectedIndex"
        (selectedTabChange)="selectedTabChange($event)"
      >
        @if (signInForm) {
          <mat-tab label="SIGN IN">
            <div class="tab-sign-in">
              <div class="form-area">
                <form class="form-sign-in" [formGroup]="signInForm" (submit)="onSignIn()">
                  <div class="form-container">
                    <mat-form-field aria-label="Email">
                      <mat-label>Email</mat-label>
                      <input matInput data-testid="email-input" title="EMAIL" formControlName="emailSignIn" />
                      <mat-error>Email required.</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-container">
                    <mat-form-field aria-label="Password">
                      <mat-label>Password</mat-label>
                      <input
                        data-testid="password-input"
                        matInput
                        title="PASSWORD"
                        type="password"
                        formControlName="passwordSignIn"
                      />
                      <mat-error>Password is required and must be at least 6 characters.</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="errors-area">
                    <p>{{ signInError }}</p>
                  </div>
                  @if (!msConnector) {
                    <div class="forgot-password">
                      <a
                        data-aria-pressed="false"
                        data-testid="recover-password-button"
                        (click)="onForgotPassword()"
                        (keydown.enter)="onForgotPassword()"
                      >
                        Forgot your password? <strong>Recover</strong>
                      </a>
                    </div>
                  }
                  <button
                    type="submit"
                    mat-raised-button
                    class="app-button sign-in bg-color-grey-700 text-color-white"
                    data-testid="signin-button"
                    [disabled]="signInForm.invalid"
                  >
                    Sign In
                  </button>
                </form>
              </div>
              <div class="or">{{ breakText }}</div>
              <!-- THIRD PARTY AUTHENTICATORS -->
              <div class="third-party-authenticators">
                @if (oAuthError) {
                  <div class="error">{{ oAuthError }}</div>
                }
                <button
                  mat-raised-button
                  class="third-party-button apple"
                  data-testid="apple-signin-button"
                  (click)="appleSignIn()"
                >
                  <span class="mat-icon-wrapper">
                    @if (isBrowser) {
                      <mat-icon svgIcon="apple_logo"></mat-icon>
                    }
                  </span>
                  <span class="third-party-text">Apple</span>
                </button>
                <button
                  mat-raised-button
                  class="third-party-button google"
                  data-testid="google-signin-button"
                  (click)="googleSignIn()"
                >
                  <span class="mat-icon-wrapper">
                    @if (isBrowser) {
                      <mat-icon svgIcon="google_logo"></mat-icon>
                    }
                  </span>
                  <span class="third-party-text">Google</span>
                </button>
                <button
                  mat-raised-button
                  class="third-party-button microsoft"
                  data-testid="microsoft-signin-button"
                  (click)="microsoftSignIn()"
                >
                  <span class="mat-icon-wrapper">
                    @if (isBrowser) {
                      <mat-icon svgIcon="microsoft_logo"></mat-icon>
                    }
                  </span>
                  <span class="third-party-text">Microsoft</span>
                </button>
              </div>
            </div>
          </mat-tab>
        }
        <!-- - - - - - - - - - - - - - - REGISTER - - - - - - - - - - - - -->
        @if (signUpForm) {
          <mat-tab label="REGISTER">
            <div class="tab-register">
              <div class="form-area">
                <form class="form-register" [formGroup]="signUpForm">
                  <div class="form-container">
                    <mat-form-field aria-label="Email">
                      <mat-label>Email</mat-label>
                      <input matInput data-testid="email-input-registration" title="EMAIL" formControlName="email" />
                      <mat-error>Email required.</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="form-row-double-field">
                    <div class="form-container">
                      <mat-form-field aria-label="First Name">
                        <mat-label>First name</mat-label>
                        <input matInput data-testid="first-name-input" title="FIRST NAME" formControlName="firstName" />
                        <mat-error>First name is required.</mat-error>
                      </mat-form-field>
                    </div>
                    <div class="form-container">
                      <mat-form-field aria-label="Last Name">
                        <mat-label>Last name</mat-label>
                        <input matInput data-testid="last-name-input" title="LAST NAME" formControlName="lastName" />
                        <mat-error>Last name is required.</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="errors-area">
                    @if (getPassword?.hasError('pattern') || getPassword?.hasError('minlength')) {
                      <div class="error-requirements-wrap">
                        <div>
                          <mat-icon
                            class="errors-area-icon"
                            [style]="{ color: getPassword?.hasError('minlength') ? 'var(--danger)' : 'var(--success)' }"
                          >
                            {{ getPassword?.hasError('minlength') ? 'clear' : 'done' }}
                          </mat-icon>
                          <p>Password must be at least 8 characters</p>
                        </div>
                        <div>
                          <mat-icon
                            class="errors-area-icon"
                            [style]="{ color: getPasswordValidation(rgxPasswordLowerAndUpper).color }"
                          >
                            {{ getPasswordValidation(rgxPasswordLowerAndUpper).icon }}
                          </mat-icon>
                          <p>Password must contain one uppercase and lowercase letter</p>
                        </div>
                        <div>
                          <mat-icon
                            class="errors-area-icon"
                            [style]="{ color: getPasswordValidation(rgxPasswordNumbers).color }"
                          >
                            {{ getPasswordValidation(rgxPasswordNumbers).icon }}
                          </mat-icon>
                          <p>Password must contain one number</p>
                        </div>
                        <div>
                          <mat-icon
                            class="errors-area-icon"
                            [style]="{ color: getPasswordValidation(rgxPasswordSpecialCharacters).color }"
                          >
                            {{ getPasswordValidation(rgxPasswordSpecialCharacters).icon }}
                          </mat-icon>
                          <p>Password must contain one special character</p>
                        </div>
                      </div>
                    }
                    @if (
                      getConfirmPassword?.value.length &&
                      getConfirmPassword?.hasError('mustMatch') &&
                      !getPassword?.hasError('minlength') &&
                      !getPassword?.hasError('pattern')
                    ) {
                      <p>Your passwords do not match</p>
                    }
                    @if (signUpForm?.hasError('wrongRegister')) {
                      <p>{{ signUpForm.errors?.wrongRegister }}</p>
                    }
                    <p *ngIf="signUpForm?.hasError('recaptchaError')">{{ signUpForm.errors?.recaptchaError }}</p>
                  </div>
                  <div class="form-row-double-field">
                    <div class="form-container">
                      <mat-form-field aria-label="Password">
                        <mat-label>Password</mat-label>
                        <input
                          matInput
                          data-testid="password-input-registration"
                          title="PASSWORD"
                          type="password"
                          formControlName="password"
                        />
                      </mat-form-field>
                    </div>
                    <div class="form-container">
                      <mat-form-field aria-label="Confirm Password">
                        <mat-label>Confirm Password</mat-label>
                        <input
                          matInput
                          data-testid="confirm-password-input-registration"
                          title="CONFIRM PASSWORD"
                          type="password"
                          formControlName="confirmPassword"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <input id="appTokenInput" #appToken type="hidden" />
                  <mat-checkbox data-testid="agree-terms-checkbox" formControlName="termsAndConditionsAccepted">
                    I agree to the
                    <a href="https://scoot.app/terms-of-use-agreement" target="_blank" rel="noopener"
                      >Terms of Service</a
                    >
                  </mat-checkbox>
                  <re-captcha
                    #captchaRef="reCaptcha"
                    size="invisible"
                    (resolved)="onRegister($event)"
                    (errored)="onError($event)"
                    errorMode="handled"
                    [siteKey]="RECAPTCHA_V2_SITE_KEY_VALUE"
                  ></re-captcha>
                </form>
                <button
                  mat-raised-button
                  data-testid="create-account-button"
                  class="app-button join-in bg-color-grey-700 text-color-white"
                  (click)="handleRegisterClick(captchaRef)"
                  [disabled]="registerDisabled()"
                >
                  Create Account
                </button>
              </div>
              <div class="or">{{ breakText }}</div>
              <!-- THIRD PARTY AUTHENTICATORS -->
              <div class="third-party-authenticators">
                @if (oAuthError) {
                  <div class="error">{{ oAuthError }}</div>
                }
                <button
                  mat-raised-button
                  class="third-party-button apple"
                  data-testid="apple-signin-button"
                  (click)="appleSignIn()"
                >
                  <span class="mat-icon-wrapper">
                    @if (isBrowser) {
                      <mat-icon svgIcon="apple_logo"></mat-icon>
                    }
                  </span>
                  <span class="third-party-text">Apple</span>
                </button>
                <button
                  mat-raised-button
                  class="third-party-button google"
                  data-testid="google-signin-button"
                  (click)="googleSignIn()"
                >
                  <span class="mat-icon-wrapper">
                    @if (isBrowser) {
                      <mat-icon svgIcon="google_logo"></mat-icon>
                    }
                  </span>
                  <span class="third-party-text">Google</span>
                </button>
                <button
                  mat-raised-button
                  class="third-party-button microsoft"
                  data-testid="microsoft-signin-button"
                  (click)="microsoftSignIn()"
                >
                  <span class="mat-icon-wrapper">
                    @if (isBrowser) {
                      <mat-icon svgIcon="microsoft_logo"></mat-icon>
                    }
                  </span>
                  <span class="third-party-text">Microsoft</span>
                </button>
              </div>
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </div>
}

<!--Sign Up Card for embedding in guest view -->

@if (!showRegister && !showLoader) {
  <div class="presentation-v1">
    <div data-testid="signup-container-div" class="sign-up bg-color-white">
      <div class="sign-up-header">
        <h4>Continue with your account</h4>
      </div>
      <div class="mobile-header">
        <div class="logo-wrapper">
          <img data-testid="scoot-logo-image" src="assets/images/logos/scoot_logo_primary.png" alt="Scoot Logo" />
        </div>
        <h4>Login</h4>
      </div>
      <div class="sign-up-body">
        <div class="form-area">
          <form class="form-sign-in" [formGroup]="signInForm" (submit)="onSignIn()">
            <div class="form-container">
              <mat-form-field class="sign-input-v1" aria-label="Email" appearance="outline">
                <mat-label>Email</mat-label>
                <input data-testid="email-input" matInput title="email" formControlName="emailSignIn" />
                <mat-error>Email required.</mat-error>
              </mat-form-field>
            </div>
            <div class="form-container">
              <mat-form-field class="sign-input-v1" aria-label="Password" appearance="outline">
                <mat-label>Password</mat-label>
                <input
                  data-testid="password-input"
                  matInput
                  title="Password"
                  type="password"
                  formControlName="passwordSignIn"
                />
                <mat-error>Password is required and must be at least 6 characters.</mat-error>
              </mat-form-field>
            </div>
            @if (signInError !== '') {
              <div class="errors-area">
                <p>{{ signInError }}</p>
              </div>
            }
            <button
              type="submit"
              mat-raised-button
              class="app-button sign-in sign-in-btn"
              data-testid="signin-button"
              [disabled]="signInForm.invalid"
              [class.disabled]="signInForm.invalid"
            >
              Login
            </button>
            @if (!msConnector) {
              <div class="forgot-password">
                <a
                  data-aria-pressed="false"
                  data-testid="recover-password-button"
                  (click)="onForgotPassword()"
                  (keydown.enter)="onForgotPassword()"
                >
                  Forgot password?
                </a>
              </div>
            }
          </form>
        </div>
        <div class="or-text">{{ breakTextV1 }}</div>
        <!-- THIRD PARTY AUTHENTICATORS -->
        <div class="third-party-authenticators">
          <button
            mat-raised-button
            class="third-party-button apple"
            data-testid="apple-signin-button"
            (click)="appleSignIn()"
          >
            <span class="mat-icon-wrapper">
              @if (isBrowser) {
                <mat-icon svgIcon="apple_logo"></mat-icon>
              }
            </span>
            <span class="third-party-text">Apple</span>
          </button>
          <button
            mat-raised-button
            class="third-party-button google"
            data-testid="google-signin-button"
            (click)="googleSignIn()"
          >
            <span class="mat-icon-wrapper">
              @if (isBrowser) {
                <mat-icon svgIcon="google_logo"></mat-icon>
              }
            </span>
            <span class="third-party-text">Google</span>
          </button>
          <button
            mat-raised-button
            class="third-party-button microsoft"
            data-testid="microsoft-signin-button"
            (click)="microsoftSignIn()"
          >
            <span class="mat-icon-wrapper">
              @if (isBrowser) {
                <mat-icon svgIcon="microsoft_logo"></mat-icon>
              }
            </span>
            <span class="third-party-text">Microsoft</span>
          </button>
        </div>
        <div class="mobile-register">
          <div class="register-text">
            <span>New to Scoot?</span>
          </div>
          <button
            type="button"
            mat-raised-button
            class="app-button sign-in sign-in-btn"
            data-testid="register-button"
            id="registerButton"
            (click)="handleRegisterButton()"
          >
            Register
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (showLoader) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}
